import React from "react";

const TehoFooter = () => {
  return (
    <footer className="footer">
      <div className="bg-footer">
        <div className="copyright">
          <p>Copyright</p>
          <i className="far fa-copyright"></i>
          <p>Labo T./Teho</p>
        </div>
        <div className="dev">
          <p>Developed by</p>
          <a
            href="https://lebolloch-dev.com/"
            target="_blank"
            title="Lebolloch_Dev"
            rel="noreferrer"
          >
            Lebolloch-Dev
          </a>
        </div>
      </div>
    </footer>
  );
};

export default TehoFooter;
